import {
    createInvoice,
    createInvoiceWithoutSquare,
    deleteInvoiceById,
    estimateInvoice,
    generateEmailEstimateInvoice,
    readInvoiceById,
    readInvoices,
    replaceInvoice,
} from 'api/invoice';
import { CreateInvoiceRequest, UpdateInvoiceRequest } from 'api/invoice/types';
import { PaginateParamsRequest } from 'types/common';
import { InvoiceFormData } from 'types/invoice';

export const createNewInvoice = (data: InvoiceFormData, appointmentId: string) => {
    const requestData: CreateInvoiceRequest = {
        ...data,
        description: data.description || null,
        appointmentId,
    };
    return createInvoice(requestData).then((res) => res.data);
};

export const createNewInvoiceWithoutSquare = (data: InvoiceFormData, appointmentId: string) => {
    const requestData: CreateInvoiceRequest = {
        ...data,
        description: data.description || null,
        appointmentId,
    };
    return createInvoiceWithoutSquare(requestData).then((res) => res.data);
};

export const estimateNewInvoice = (appointmentId: string) =>
    estimateInvoice({ appointmentId }).then((res) => res.data.total);

export const generateEmailEstimateNewInvoice = (
    data: InvoiceFormData,
    appointmentId: string,
    asAppointmentUser: boolean,
) => {
    const requestData: CreateInvoiceRequest = {
        ...data,
        description: data.description || null,
        appointmentId,
    };
    return generateEmailEstimateInvoice(requestData, asAppointmentUser).then((res) => res.data.total);
};

export const updateInvoice = (data: InvoiceFormData, appointmentId: string, invoiceId: string) => {
    const requestData: UpdateInvoiceRequest = {
        ...data,
        description: data.description || null,
        appointmentId,
    };
    return replaceInvoice(requestData, invoiceId).then((res) => res.data);
};

export const getInvoicesByAppointment = (params: PaginateParamsRequest, appointmentId?: string) => {
    const requestParams = {
        ...params,
        appointmentIds: appointmentId ? [appointmentId] : undefined,
    };
    console.log({ requestParams });
    return readInvoices(requestParams).then((res) => res.data);
};

export const getInvoiceDetails = (id: string) => readInvoiceById({ id }).then(({ data }) => data);

export const getInvoiceFormData = (id: string): Promise<InvoiceFormData> =>
    readInvoiceById({ id }).then(({ data }) => {
        const { scheduledPayDate, title, description } = data;

        return {
            scheduledPayDate: scheduledPayDate || '',
            title,
            description,
        };
    });

export const deleteInvoice = (id: string) => {
    return deleteInvoiceById({ id }).then((res) => res.data);
};
